import store from "@/store/index.store"

import MainLayout from "@/layouts/MainLayout.vue"
import BannerLayout from "@/layouts/BannerLayout.vue"

import { GAME_KEYS } from "@/store/game/game.constants"
import { ROUTER_NAMES } from "@/constants/router.constants"

const LeagueOfLegendsImageBackground =
  "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL2xlYWd1ZW9mbGVnZW5kcy9nYW1lLWJhbm5lcl9iYWNrZ3JvdW5kLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MTkyMCwiaGVpZ2h0IjoyNzksImZpdCI6ImNvdmVyIn19fQ=="
const LeagueOfLegendsImageForeground =
  "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL2xlYWd1ZW9mbGVnZW5kcy9nYW1lLWJhbm5lcl9mb3JlZ3JvdW5kLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6ODk1LCJoZWlnaHQiOjMwMiwiZml0IjoiY292ZXIifX19"

// League of Legends Pages
const Champions = () =>
  import(
    /* webpackChunkName: "league-of-legends-resources" */ "@/pages/league_of_legends/Champions"
  )
const ChampionsTierList = () =>
  import(
    /* webpackChunkName: "league-of-legends-resources" */ "@/pages/league_of_legends/ChampionsTierList"
  )
const ChampionPage = () =>
  import(
    /* webpackChunkName: "league-of-legends-resources" */ "@/pages/league_of_legends/ChampionPage"
  )

export default [
  {
    path: "/leagueoflegends/champions",
    redirect: "/leagueoflegends/champions/search",
    name: ROUTER_NAMES.LOL_CHAMPIONS,
    component: Champions,
    meta: {
      game: GAME_KEYS.LEAGUE_OF_LEGENDS,
      layout: {
        component: MainLayout,
        child: {
          component: BannerLayout,
          props: {
            bannerImageBackground: LeagueOfLegendsImageBackground,
            bannerImageForeground: LeagueOfLegendsImageForeground,
          },
        },
      },
    },
    beforeEnter: (_to, _from, next) => {
      store.dispatch("LeagueOfLegends/loadStaticData")
      next()
    },
    children: [
      {
        path: "search",
        name: "ChampionsTierList",
        component: ChampionsTierList,
      },
      {
        path: ":championName",
        name: "ChampionPage",
        component: ChampionPage,
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/router/leagueoflegends.routes.js